import axios from "../utils/axios";

const API_URL = process.env.REACT_APP_API_URL + "/v1/admin";

const getSystemStatus = (config = {}) => {
    return axios.get(`${API_URL}/system-status`, config);
};

const systemStatusService = {
    getSystemStatus,
};

export default systemStatusService;
